<svelte:options tag="unescap-timeline" />

<script>
import {
  onMount,
  onDestroy,
} from 'svelte'
import { get_current_component } from 'svelte/internal'

import Slider from '../bootstrap-slider/bootstrap-slider'

/** Input props */
export let min = '1990'
export let max = '2025'
export let value = '2024'
export let range
// --


const component = get_current_component()
let containerWidth

$: isRange = range !== undefined && range !== false

$: {
  const { isNew } = getTickContainerEl()
  if (isNew === false) { // Skip first render
    const { min, max } = getFormatProps()
    setTickMarks({ width: containerWidth, min, max })
  }
}

function getFormatProps() {
  const _min = parseInt(min)
  const _max = parseInt(max)
  const _value = value.split(',').map(v => parseInt(v)) // E.g. 1990, 2025
  const _range = range !== undefined && range !== false // E.g. [rage], [range="true"]
  return { min: _min, max: _max, value: _value, range: _range }
}

function getSliderEl() {
  return component.shadowRoot.querySelector('#timelineGraph')
}

function getTickContainerEl() {
  const className = 'container-tick'
  let $el = component.shadowRoot.querySelector(`.${className}`)
  if ($el !== null) {
    return { $el, isNew: false }
  }
  $el = document.createElement('div')
  $el.setAttribute('class', className)
  return { $el: $el, isNew: true }
}

function setTickMarks({ width, min, max }) {
  const range = max - min
  const tickSpace = width / range
  const { $el: $tickContainer } = getTickContainerEl()
  $tickContainer.innerHTML = '' // Clear old content
  for (let i = 0; i <= range; i++) {
    const $tick = document.createElement('div')
    $tick.setAttribute('class', 'slider-tick')
    $tick.style.left = `${(i * tickSpace)}px`
    $tickContainer.append($tick)
  }
  const $slider = getSliderEl()
  $slider.append($tickContainer)
}

function getCustomEvent(name, value) {
  return new CustomEvent(name, {
    detail: { value },
    bubbles: true,
    composed: true, // For bubbling beyone shadow DOM boundaries
  })
}

function init({ min, max, value, range }) {
  const $el = getSliderEl()
  const sliderId = 'timelineGraph'
  const timelineSlider = new Slider($el, {
    id: sliderId,
    min,
    max,
    value: range ? value : value[0],
    tooltip: 'always',
    focus: true,
    range,
  })
  timelineSlider
    .on('change', value => {
      // console.log('change', value)
      const eventSlide = getCustomEvent('change', value.newValue)
      component.dispatchEvent(eventSlide)
    })
    .on('slideStart', value => {
      // console.log('slideStart', value)
      const eventSlideStart = getCustomEvent('slideStart', value)
      component.dispatchEvent(eventSlideStart)
    })
    .on('slideStop', value => {
      // console.log('slideStop', value)
      const eventSlideStop = getCustomEvent('slideStop', value)
      component.dispatchEvent(eventSlideStop)
    })
  setTimeout(() => {
    setTickMarks({ width: containerWidth, min, max })
  }, 500) // Waiting fro Slider render
}

onMount(() => {
  // console.log('UnescapTimeline component mounted', min, max, value, process.env.prod)
  init(getFormatProps())
})
</script>

<div id="unescapTimeline"
    class:range-slider={isRange}
    class:single-slider={!isRange}
    bind:clientWidth={containerWidth}>
  <div
    id="timelineGraph"></div>
  <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@4.6.2/dist/css/bootstrap.min.css">
  {#if process.env.prod}
    <link rel="stylesheet" href="/themes/custom/tbdtheme/assets/dist-webcomponents/svelte/vendor/bootstrap-slider/bootstrap-slider.css">
    <link rel="stylesheet" href="/themes/custom/tbdtheme/assets/dist-webcomponents/svelte/vendor/bootstrap-slider/bootstrap-slider-custom.css">
  {:else}
    <link rel="stylesheet" href="./build/vendor/bootstrap-slider/bootstrap-slider.css">
    <link rel="stylesheet" href="./build/vendor/bootstrap-slider/bootstrap-slider-custom.css">
  {/if}
</div>
